// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM9 12V8H7V12H9ZM17 12V8H15V12H17ZM9.40076 14.4993L8.90004 13.6337L7.16882 14.6351L7.66955 15.5007C8.53256 16.9926 10.1481 18 12 18C13.852 18 15.4675 16.9926 16.3305 15.5007L16.8312 14.6351L15.1 13.6337L14.5993 14.4993C14.0791 15.3986 13.1092 16 12 16C10.8909 16 9.92099 15.3986 9.40076 14.4993Z"}}]};

const SmileFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'smile-filled',
    ref,
    icon: element,
  },
));

SmileFilledIcon.displayName = 'SmileFilledIcon';

export default SmileFilledIcon;
